<div class="view-request-container">
  <div class="view-request-header">
    <button (click)="router.navigate(['/customs-broker/dashboard'])" class="btn btn-back">
      ← {{ backText }}
    </button>
    <h1>{{ titleText }} {{ requestId | docNo:'R':request?.createdAt }}</h1>
    <div class="header-actions">
      <button *ngIf="requestId" type="button" class="btn btn-chat" (click)="scrollToChat()">
        💬 {{ chatButtonText }}
      </button>
    </div>
  </div>

  <div class="view-request-content">
    <app-view-request-base *ngIf="requestId" [requestId]="requestId"></app-view-request-base>

    <app-request-bids-section *ngIf="requestId" [cargoRequestId]="requestId" bidViewRoutePrefix="customs-broker"></app-request-bids-section>

    <!-- Секция товаров для расчета таможенных платежей -->
    <div class="customs-products-section" *ngIf="request?.calculateCustomsPayments">
      <h2>{{ customsProductsSectionTitleText }}</h2>

      <div *ngIf="loadingRequest" class="loading">
        {{ loadingText }}
      </div>

      <div *ngIf="errorRequest" class="error">
        {{ errorRequest }}
      </div>

      <div *ngIf="request?.customsCalculationCompleted" class="calculation-status completed">
        <span class="status-icon">✓</span>
        <span>{{ calculationCompletedText }}</span>
      </div>
      <div *ngIf="request?.customsCalculationStarted && !request?.customsCalculationCompleted" class="calculation-status in-progress">
        <span class="status-icon">🔄</span>
        <span>{{ calculationInProgressText }}</span>
      </div>
      <div *ngIf="!request?.customsCalculationStarted && !request?.customsCalculationCompleted" class="calculation-status pending">
        <span class="status-icon">⏳</span>
        <span>{{ calculationPendingText }}</span>
      </div>

      <form [formGroup]="productsForm" *ngIf="!loadingRequest && !errorRequest">
        <div formArrayName="products">
          <div *ngIf="productsArray.length === 0" class="no-customs-products">
            {{ noCustomsProductsText }}
          </div>

          <div *ngIf="productsArray.length > 0" class="customs-products-form">
            <div class="table-wrapper">
              <table class="customs-products-table">
              <thead>
                <tr>
                  <th>{{ productNameText }}</th>
                  <th>{{ productTnvedText }}</th>
                  <th>{{ productCostText }}</th>
                  <th>{{ customsFeesText }}</th>
                  <th>{{ customsDutyText }}</th>
                  <th>{{ vatText }}</th>
                  <th>{{ nonTariffRegulationMeasuresText }}</th>
                  <th>{{ totalPaymentsText }}</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let productGroup of productsArray.controls; let i = index" [formGroupName]="i">
                  <td>
                    <div class="product-name-section">
                      <div class="original-name">{{ productGroup.get('nameOriginal')?.value }}</div>
                      <input 
                        type="text" 
                        formControlName="nameForBroker"
                        class="form-control"
                        [readonly]="request?.customsCalculationCompleted || !request?.customsCalculationStarted"
                        [placeholder]="productNameForBrokerPlaceholderText"
                      />
                    </div>
                  </td>
                  <td>
                    <div class="product-tnved-section">
                      <div class="original-tnved">{{ productGroup.get('tnvedCodeOriginal')?.value || '-' }}</div>
                      <input 
                        type="text" 
                        formControlName="tnvedCodeForBroker"
                        class="form-control"
                        [readonly]="request?.customsCalculationCompleted || !request?.customsCalculationStarted"
                        [placeholder]="productTnvedForBrokerPlaceholderText"
                      />
                    </div>
                  </td>
                  <td class="product-cost">
                    {{ productGroup.get('productCost')?.value | number:'1.2-2' }}
                  </td>
                  <td>
                    <input 
                      type="number" 
                      formControlName="customsFees"
                      class="form-control"
                      step="0.01"
                      min="0"
                      [readonly]="request?.customsCalculationCompleted"
                      placeholder="0.00"
                    />
                  </td>
                  <td>
                    <input 
                      type="number" 
                      formControlName="customsDuty"
                      class="form-control"
                      step="0.01"
                      min="0"
                      [readonly]="request?.customsCalculationCompleted"
                      placeholder="0.00"
                    />
                  </td>
                  <td>
                    <input 
                      type="number" 
                      formControlName="vat"
                      class="form-control"
                      step="0.01"
                      min="0"
                      [readonly]="request?.customsCalculationCompleted"
                      placeholder="0.00"
                    />
                  </td>
                  <td>
                    <textarea 
                      formControlName="nonTariffRegulationMeasures"
                      class="form-control"
                      rows="2"
                      [readonly]="request?.customsCalculationCompleted"
                      [placeholder]="nonTariffRegulationMeasuresText"
                    ></textarea>
                  </td>
                  <td class="total-payments">
                    {{ productGroup.get('totalCustomsPayments')?.value | number:'1.2-2' }}
                  </td>
                </tr>
              </tbody>
              <tfoot>
                <tr>
                  <td colspan="7" class="total-label">{{ totalLabelText }}</td>
                  <td class="total-amount">
                    {{ getTotalAllPayments() | number:'1.2-2' }}
                  </td>
                </tr>
              </tfoot>
            </table>
            </div>

            <div class="form-actions" *ngIf="!request?.customsCalculationCompleted">
              <!-- Кнопка "Взять в работу" показывается только если расчет еще не начат -->
              <button 
                *ngIf="!request?.customsCalculationStarted"
                type="button"
                (click)="startCalculation()" 
                class="btn btn-warning"
                [disabled]="!canStart() || submitting"
              >
                {{ submitting ? startingText : startCalculationText }}
              </button>
              
              <!-- Кнопки "Сохранить" и "Завершить" показываются только если расчет уже начат -->
              <div *ngIf="request?.customsCalculationStarted" class="work-buttons">
                <button 
                  type="button"
                  (click)="saveChanges()" 
                  class="btn btn-primary"
                  [disabled]="!canSave()"
                >
                  {{ submitting ? savingText : saveChangesText }}
                </button>
                <button 
                  type="button"
                  (click)="completeCalculation()" 
                  class="btn btn-success"
                  [disabled]="!canComplete() || submitting"
                >
                  {{ submitting ? completingText : completeCalculationText }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </form>

      <div *ngIf="success" class="success-message">
        {{ request?.customsCalculationStarted && !request?.customsCalculationCompleted ? saveSuccessText : (request?.customsCalculationCompleted ? completeSuccessText : startSuccessText) }}
      </div>
      <div *ngIf="error" class="error-message">
        {{ error }}
      </div>
    </div>
  </div>

  <div class="request-chat" id="chat" *ngIf="requestId">
    <app-chat-threads [requestId]="requestId" [locked]="!!request?.hasDeal" [initialForwarderId]="chatForwarderId"></app-chat-threads>
  </div>
</div>
